<template>
  <div class="content">
    <div class="main">
      <div class="offer">
        <div class="offer-title">{{measure2}}㎡</div>
        <div class="money">总金额: ¥ {{money}}</div>
      </div>
      <div class="kitchmain" v-for="(item,index) in Kitchen" :key="index">
        <div class="Kitchentitle">
          <div class="Kitchen-left">{{item.spactname}}</div>
        </div>
        <!-- <div class="Kitchen-main">
          <div class="blockleft">{{item.itemdata.matgroupname}}</div>
          <div class="blockleft">不限数量</div>
          <div class="blockleft">
            <div v-if="item.matimagemid != null">
              <img :src="item.matimagemid">
            </div>
            <span v-if="item.matimagemid == null">自由选择</span>
          </div>
          <div class="blockleft">{{item.matgroupname}}/{{item.brand}}</div>
        </div>-->
        <el-table :data="item.itemdata" style="width: 100%">
          <el-table-column prop="matgroupname" label="品类" width></el-table-column>
          <el-table-column prop="uom" label="单位" width></el-table-column>
          <el-table-column prop="formula" label="数量" width></el-table-column>
          <el-table-column prop="vndname" label="可选品牌" width></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  props: ["measure", "databiog"],
  watch: {},
  data() {
    return {
      datas: "",
      money: "",
      Kitchen: [],
      measure2: ""
    };
  },
  methods: {
    gethtml: async function() {
      //console.log("databiog", this.databiog);
      let databiog = this.databiog;
      let data = {
        setid: 15
      };
      let res = await this.exequy.gethtmllist(data);
      //console.log("res222", res);
      this.datas = res.data.data[0];
      //console.log("res222", this.datas);
      if (databiog == undefined) {
        this.measure2 = this.measure;
        let resa = this.measure - this.datas.basesquare;
        //console.log("resa", resa);
        if (resa >= 0) {
          this.money =
            this.datas.ztotalmoney +
            (this.measure - this.datas.basesquare) * this.datas.zaddmoney;
          //console.log("mo", this.money);
        } else {
          this.money =
            this.datas.ztotalmoney +
            (this.measure - this.datas.basesquare) * this.datas.zreducemoney;
        }
      } else {
        this.measure2 = databiog.measure;
        let resa = databiog.measure - this.datas.basesquare;
        //console.log("reasaaa", resa);
        if (resa >= 0) {
          this.money =
            this.datas.ztotalmoney +
            (databiog.measure - this.datas.basesquare) * this.datas.zaddmoney +
            (databiog.Wei - 1) * this.datas.zbathroom +
            (databiog.kitchen - 1) * this.datas.zkitchen;
          //console.log("mo", this.money);
        } else {
          this.money =
            this.datas.ztotalmoney +
            (databiog.measure - this.datas.basesquare) *
              this.datas.zreducemoney +
            (databiog.Wei - 1) * this.datas.zbathroom +
            (databiog.kitchen - 1) * this.datas.zkitchen;
        }
      }
    },
    getjson: async function() {
      let data = {
        setid: 15
      };
      let resp = await this.exequy.pkdetails(data);
      this.Kitchen = resp.data.data;
      this.gethtml();
      //console.log("this.Kitchen", this.Kitchen);
      this.Kitchen.map(vl => {
        vl.itemdata.map(vs => {
          if (vs.formula == "") {
            vs.formula = vs.digit.split(".")[0];
          } else {
            vs.formula = "按面积换算";
          }
        });
      });
    }
  },
  created: async function() {
    let self = this;
    self.getjson();
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.offer-title {
  width: 40%;
  height: 100px;
  line-height: 100px;
  float: left;
  font-size: 30px;
}
.money {
  width: 60%;
  height: 100px;
  line-height: 100px;
  float: left;
  color: #c81622;
  font-size: 30px;
}
.kitchmain {
  width: 95%;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 5px;
}

.Kitchentitle {
  width: 100%;
}
.Kitchen-left {
  width: 100%;
  float: left;
  background: #b31d25;
  color: #fff;
  font-size: 20px;
  height: 2rem;
  line-height: 2rem;
}
.Kitchen-right {
  width: 100%;
  float: left;
  border-bottom: 1px solid #ddd;
}
/* .Kitchen-main ul li {
  list-style: none;
  width: 200px;
}
.Kitchen-main ul {
  overflow: hidden;
}
.Kitchen-main ul li img {
  width: 100%;
  height: 100%;
} */
.liname {
  font-size: 14px;
  text-align: left;
  color: #827c7c;
}
/* .blockleft{
  width: 20.8%;
  float: left;
  line-height: 30px;
  border-bottom: 1px solid #ddd;
}
.blockleft img {
  width: 100%;
  height: 100%;
} */
</style>
